import {FeatureFlag} from "@services/featureFlagConstants";
import {useTypedSelector} from "src/store";

export function useFeatureFlag<T>(flagName: FeatureFlag): T {
  return useTypedSelector(state => state.featureFlags[flagName]) as T;
}
